
import { Component, Vue, Watch } from 'vue-property-decorator';
import { Getter, Mutation } from "vuex-class";
import HotkeyInfo from "@/components/SlideOut/HotkeyInfo.vue";
import { EventBus } from "@/Services/helpers/EventBus";
import UndoService from "@/Services/UndoService";

  @Component export default class Navbar extends Vue {
    @Getter('sections') sections: Selection[];
    @Getter('speakers') speakers: string[];
    @Getter('undoQueue') undoQueue: UndoService[];
    @Getter('redoQueue') redoQueue: UndoService[];
    @Getter('media') media: HTMLMediaElement;
    @Getter('selectedWordIds') selectedWordIds:  number[];
    @Getter('email') email: string;
    @Getter('currentTime') currentTime: number;
    @Getter('mediaIsPlaying') mediaIsPlaying: boolean;
    @Getter('scrollIntoViewEnabled') scrollIntoViewEnabled: boolean;

    @Mutation('setMediaIsPlaying') setMediaIsPlaying: (mediaPlayingStatus: boolean) => void;
    @Mutation('setScrollIntoViewEnabled') setScrollIntoViewEnabled: (scrollIntoViewEnabled: boolean) => void;

    mounted() {
    }

    destroyed() {
    }

    playingStatus: boolean = false;
    @Watch('playingStatus')
    onPlayingStatusChange(val) {
      this.setMediaIsPlaying(val);
    }

    @Watch('$store.getters.media')
    onMediaChanged(val, oldval) {
      this.media && this.media.addEventListener("pause", () => {
        this.playingStatus = false;
      });
      this.media && this.media.addEventListener("playing", () => {
        this.playingStatus = true;
      });
    }

    showHotkeyInfoPanel() {
      // @ts-ignore
      const panel = this.$showPanel({
        component : HotkeyInfo,
        openOn: 'right',
        width: 350,
        props: {

        },
      });
    }

    emitGlobalEvent(event: string) {
      EventBus.$emit(event);
    }

    openNew() {
      const routeData = this.$router.resolve({name: 'import', query: {locale: this.$i18n.locale}});
      window.open(routeData.href, '_blank');
    }
}

